import { api } from '../utils/api'
import type { Profile, AppModuleInfo, PermissionsMap } from '../types/@types/user'

export async function getProfiles(): Promise<Profile[]> {
  const { data } = await api.get('/profiles')
  return data
}

export async function getProfile(id: number): Promise<Profile> {
  const { data } = await api.get(`/profiles/${id}`)
  return data
}

export async function createProfile(payload: {
  name: string
  description?: string
  permissions: Array<{ module: string } & { can_view: boolean; can_create: boolean; can_edit: boolean; can_delete: boolean }>
}): Promise<Profile> {
  const { data } = await api.post('/profiles', payload)
  return data
}

export async function updateProfile(
  id: number,
  payload: { name: string; description?: string; permissions: Array<{ module: string; can_view: boolean; can_create: boolean; can_edit: boolean; can_delete: boolean }> }
): Promise<Profile> {
  const { data } = await api.put(`/profiles/${id}`, payload)
  return data
}

export async function deleteProfile(id: number): Promise<void> {
  await api.delete(`/profiles/${id}`)
}

export async function getModules(): Promise<AppModuleInfo[]> {
  const { data } = await api.get('/profiles/modules')
  return data
}

export function permissionsMapToArray(permissions: PermissionsMap) {
  return Object.entries(permissions).map(([module, p]) => ({
    module,
    can_view:   p.can_view,
    can_create: p.can_create,
    can_edit:   p.can_edit,
    can_delete: p.can_delete,
  }))
}
